import { supabase } from './supabaseClient';

export const fetchTestimonials = async () => {
    const { data, error } = await supabase
        .from('testimonials')
        .select('*')
        .order('created_at', { ascending: false });
    
    if (error) {
        console.error('Error fetching testimonials:', error);
        return [];
    }
    return data;
};

export const createTestimonial = async (testimonialData) => {
    const { data, error } = await supabase
        .from('testimonials')
        .insert([testimonialData])
        .select();
    
    if (error) {
        console.error('Error creating testimonial:', error);
        throw error;
    }
    return data[0];
};

export const updateTestimonial = async (id, testimonialData) => {
    const { data, error } = await supabase
        .from('testimonials')
        .update(testimonialData)
        .eq('id', id)
        .select();
    
    if (error) {
        console.error('Error updating testimonial:', error);
        throw error;
    }
    return data[0];
};

export const deleteTestimonial = async (id) => {
    const { error } = await supabase
        .from('testimonials')
        .delete()
        .eq('id', id);
    
    if (error) {
        console.error('Error deleting testimonial:', error);
        throw error;
    }
};
